import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  CreateFacilityAdmin,
  FacilityAdmins,
  FacilityAdminsRequest,
  PagedResultDto,
  UpdateFacilityAdmin,
  TerminateFacilityAdmin,
} from '@umss/shared/data-access';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FacilityAdminsService {
  private readonly baseUrl = '/api/facility-admins';

  private http = inject(HttpClient);

  get(
    request: Partial<FacilityAdminsRequest>
  ): Observable<PagedResultDto<FacilityAdmins>> {
    const params = HttpHelper.toHttpParams(request ?? {});
    return this.http.get<PagedResultDto<FacilityAdmins>>(this.baseUrl, {
      params,
    });
  }

  getById(facilityId: string): Observable<FacilityAdmins> {
    return this.http.get<FacilityAdmins>(`${this.baseUrl}/${facilityId}`);
  }

  create(
    facilityId: string,
    payload: CreateFacilityAdmin
  ): Observable<FacilityAdmins> {
    const params = HttpHelper.toHttpParams({
      facilityId,
    });
    return this.http.post<FacilityAdmins>(this.baseUrl, payload, {
      params,
    });
  }

  update(id: string, payload: UpdateFacilityAdmin): Observable<FacilityAdmins> {
    return this.http.put<FacilityAdmins>(`${this.baseUrl}/${id}`, payload);
  }

  delete(facilityId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${facilityId}`);
  }

  terminate(id: string, payload: TerminateFacilityAdmin): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/terminate`, payload);
  }

  sendInvitation(id: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/send-invitation`, {});
  }

  resetPassword(id: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/reset-password`, {});
  }
}
